import { render, staticRenderFns } from "./rankPage.vue?vue&type=template&id=721ca086&scoped=true"
import script from "./rankPage.vue?vue&type=script&lang=js"
export * from "./rankPage.vue?vue&type=script&lang=js"
import style0 from "./rankPage.vue?vue&type=style&index=0&id=721ca086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721ca086",
  null
  
)

export default component.exports